interface Props {
  onScanAgain?: () => void;
  onDownload?: () => void;
  downloadLabel?: string;
  downloadDisabled?: boolean;
  learnMoreHref?: string;
  registerHref?: string;
}

export default function PublicCtaBox({
  onScanAgain,
  onDownload,
  downloadLabel = 'Download PDF',
  downloadDisabled = false,
  learnMoreHref = '/seo-concepts/website-health-check/',
  registerHref = '/asneris-seo-engine',
}: Props) {
  const handleDownload = () => {
    if (onDownload) {
      onDownload();
      return;
    }
    window.print();
  };

  const handleScanAgain = onScanAgain ?? (() => window.location.reload());

  const items = [
    {
      title: 'Download Report',
      description: 'Save or print this report for review and sharing.',
      action: handleDownload,
      label: downloadLabel,
      accent: '#2563eb',
      disabled: downloadDisabled,
    },
    {
      title: 'Learn About This Report',
      description: 'Understand each check and how to improve the findings.',
      href: learnMoreHref,
      label: 'Learn More',
      accent: '#ea580c',
    },
    {
      title: 'Create Free Account',
      description: 'Create an Asneris account when you are ready.',
      href: registerHref,
      label: 'Create Account',
      accent: '#7e22ce',
    },
  ];

  return (
    <section
      className="asneris-report-card"
      style={{
        marginTop: '16px',
        padding: '18px',
        background: 'rgba(255,255,255,.96)',
        border: '1px solid rgba(15,54,99,.12)',
        borderRadius: '14px',
        boxShadow: '0 10px 28px rgba(4,34,73,.08)',
      }}
    >
      <h2 style={{ margin: '0 0 14px', fontSize: '17px', color: 'var(--asneris-navy)' }}>
        What&apos;s Next?
      </h2>

      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(210px, 1fr))',
          gap: '12px',
        }}
      >
        {items.map((item) => (
          <div
            key={item.title}
            style={{
              padding: '14px',
              border: '1px solid var(--asneris-border)',
              borderRadius: '10px',
              background: '#fff',
              display: 'flex',
              flexDirection: 'column',
              minHeight: '126px',
            }}
          >
            <strong style={{ fontSize: '13px', color: 'var(--asneris-navy)' }}>{item.title}</strong>
            <p style={{ margin: '5px 0 12px', fontSize: '11px', lineHeight: 1.5, color: 'var(--asneris-muted)' }}>
              {item.description}
            </p>

            {item.href ? (
              <a
                href={item.href}
                className="asneris-btn asneris-btn-secondary asneris-btn-sm"
                style={{
                  marginTop: 'auto',
                  justifyContent: 'center',
                  borderColor: item.accent,
                  color: item.accent,
                }}
              >
                {item.label}
              </a>
            ) : (
              <button
                type="button"
                className="asneris-btn asneris-btn-secondary asneris-btn-sm"
                onClick={item.action}
                disabled={item.disabled}
                style={{
                  marginTop: 'auto',
                  justifyContent: 'center',
                  borderColor: item.accent,
                  color: item.accent,
                  background: '#fff',
                }}
              >
                {item.label}
              </button>
            )}
          </div>
        ))}
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '14px' }}>
        <button
          type="button"
          className="asneris-btn asneris-btn-secondary asneris-btn-sm"
          onClick={handleScanAgain}
          style={{
            justifyContent: 'center',
            gap: '6px',
            borderColor: '#15803d',
            color: '#15803d',
            background: '#fff',
          }}
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M20 12a8 8 0 11-2.34-5.66M20 4v5h-5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          Scan Again
        </button>
      </div>
    </section>
  );
}
